export default "__VITE_ASSET__842bcbec__"